import { VStack } from '@chakra-ui/react';
import React from 'react';

import { ReceivableReconciliationAlert } from './ReceivableReconciliationAlert';
import { ReceivableReconciliationAlertProvider } from './ReceivableReconciliationAlertContext';
import { UploadDrawerAlert } from './UploadDrawerAlert';
import { UploadSingleInput } from './UploadSingleInput';
import { useUploadContextMeshInputs } from 'packages/dataPipeline/hooks/UploadContext';
import { SectionHeader } from 'packages/dataPipeline/ui/components/SectionHeader';

export const UploadContainer = ({
  closeDrawer,
}: {
  closeDrawer: () => void;
}) => {
  const meshInputs = useUploadContextMeshInputs();
  return (
    <ReceivableReconciliationAlertProvider>
      <UploadDrawerAlert />
      <ReceivableReconciliationAlert />
      <SectionHeader title="Upload Files" />
      <VStack spacing="8px" alignItems="flex-start" width="100%">
        {meshInputs.map((meshInput) => {
          return (
            <UploadSingleInput
              key={meshInput.artifactId}
              meshInput={meshInput}
              closeDrawer={closeDrawer}
            />
          );
        })}
      </VStack>
    </ReceivableReconciliationAlertProvider>
  );
};
